export default {
  PAIS: 'Chile'
};
